import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CONTACT_DETAILS, SOCIAL_LINKS } from '@/Lib/siteData';
import { useAppContext } from '@/Components/Providers/AppProvider';
import { useMediaQuery } from '@uidotdev/usehooks';

type Props = {}

export default function NavigationFooter({ }: Props) {
    const isDesktop = useMediaQuery('(min-width: 768px)');

    const {
        miniContactMenu: [open, setOpen],
    } = useAppContext();

    const handleContactClick = () => {
        setOpen(!open);
    };

    if (isDesktop) {
        return <div className="z-50 bg-light">
            <footer className="h-full p-8 pt-16 border-t-2 border-brand space-y-8">
                <div className="grid grid-cols-2 md:grid-cols-3 grid-rows-1">
                    <div className="flex flex-col justify-end md:col-span-2 font-medium uppercase space-y-6">
                        <ul>
                            <li>Cape Town</li>
                            <li>South Africa</li>
                        </ul>
                    </div>

                    <div className="col-span-1 font-medium uppercase space-y-6">
                        <div className="h-max flex justify-start items-center text-md mb-16">
                            <button className="group rounded-full px-6 py-2 hover:bg-brand uppercase font-medium border-2 border-brand cursor-pointer overflow-hidden transition-all ease-in-out duration-500" onClick={handleContactClick}>
                                <div className="relative overflow-hidden">
                                    <span className="block h-min group-hover:-translate-y-full transition-all ease-in-out duration-250">Get In Contact</span>
                                    <span className="absolute top-0 left-0 h-min text-font translate-y-full group-hover:translate-none transition-all ease-in-out duration-250">Get In Contact</span>
                                </div>
                            </button>
                        </div>
                        <ul className="space-y-4 text-sm lg:text-lg">
                            <li><a href={`mailto:${CONTACT_DETAILS.email}`} className="pb-1 border-b-2">{CONTACT_DETAILS.email}</a></li>
                            <li><a href={CONTACT_DETAILS.whatsapp} target="_blank" rel="noopener noreferrer" className="pb-1 border-b-2">{CONTACT_DETAILS.cellphone}</a></li>
                        </ul>
                        <ul className="flex flex-row justify-start gap-4 pt-8">
                            {SOCIAL_LINKS.filter(({ type }) => type !== 'email').map(({ href, handle, icon }) => <li key={`${href}_${handle}`}>
                                <a href={href}>
                                    <FontAwesomeIcon icon={icon} size="2x" />
                                </a>
                            </li>)}
                        </ul>
                    </div>
                </div>
                <span className="py-8 uppercase text-sm" dangerouslySetInnerHTML={{ __html: CONTACT_DETAILS.companyLegalName }}></span>
            </footer>
        </div>
    }

    return <div className="pt-8 z-50 bg-light">
        <footer className="h-full p-4 pt-8 border-t-2 border-brand space-y-8">
            <div className="grid grid-cols-1 grid-rows-1">
                <div className="col-span-1 font-medium uppercase space-y-8">
                    <div className="h-max flex justify-start items-center text-md mb-8">
                        <button className="group rounded-full px-6 py-2 hover:bg-brand uppercase font-medium border-2 border-brand cursor-pointer overflow-hidden transition-all ease-in-out duration-500" onClick={handleContactClick}>
                            <div className="relative overflow-hidden">
                                <span className="block h-min group-hover:-translate-y-full transition-all ease-in-out duration-250">Get In Contact</span>
                                <span className="absolute top-0 left-0 h-min text-font translate-y-full group-hover:translate-none transition-all ease-in-out duration-250">Get In Contact</span>
                            </div>
                        </button>
                    </div>
                    <ul className="space-y-4 text-sm lg:text-lg">
                        <li><a href={`mailto:${CONTACT_DETAILS.email}`} className="pb-1 border-b-2">{CONTACT_DETAILS.email}</a></li>
                        <li><a href={CONTACT_DETAILS.whatsapp} target="_blank" rel="noopener noreferrer" className="pb-1 border-b-2">{CONTACT_DETAILS.cellphone}</a></li>
                    </ul>
                    <ul className="flex flex-row justify-start gap-4 pt-4">
                        {SOCIAL_LINKS.filter(({ type }) => type !== 'email').map(({ href, handle, icon }) => <li key={`${href}_${handle}`}>
                            <a href={href}>
                                <FontAwesomeIcon icon={icon} size="2x" />
                            </a>
                        </li>)}
                    </ul>
                </div>
            </div>
            <div className="flex flex-col justify-end font-medium uppercase space-y-2">
                <ul>
                    <li>Cape Town</li>
                    <li>South Africa</li>
                </ul>
            </div>
            <span className="py-4 uppercase text-xs md:text-sm" dangerouslySetInnerHTML={{ __html: CONTACT_DETAILS.companyLegalName }}></span>
        </footer>
    </div>
}
